import getters from './getters';
import mutations from './mutations';
var state = () => ({
  notification: {}
});
export default {
  namespaced: true,
  state,
  mutations,
  getters
};